import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography, Alert } from '@mui/material';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const StripePaymentForm = ({ amount, currency, onSuccess, onError }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setProcessing(true);
        setError(null);

        try {
            const { error: submitError } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `${window.location.origin}/payment-success`,
                },
                redirect: 'if_required'
            });

            if (submitError) {
                setError(submitError.message);
                setProcessing(false);
                if (onError) onError(submitError.message);
            } else {
                // Payment succeeded
                if (onSuccess) onSuccess();
            }
        } catch (err) {
            setError(err.message);
            setProcessing(false);
            if (onError) onError(err.message);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Payment Amount: {currency.toUpperCase()} ${amount}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Enter your card details below
                </Typography>
            </Box>

            <PaymentElement />

            {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                    {error}
                </Alert>
            )}

            <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={!stripe || processing}
                sx={{ mt: 3 }}
            >
                {processing ? (
                    <CircularProgress size={24} color="inherit" />
                ) : (
                    `Pay ${currency.toUpperCase()} $${amount}`
                )}
            </Button>
        </form>
    );
};

export default StripePaymentForm;